import { createElement } from 'react'
import { google as googleFn } from 'calendar-link'

import { CalGoogleIcon } from '@pleio/icons/cal-google'

import { type CalendarEvent } from '../CalendarEvent'
import { type WebCalendarService } from '../CalendarLink'
import descriptionAsHtml from '../descriptionAsHtml'
import normalizeLocation from '../normalizeLocation'

export default function google(
    label: string,
): (event: CalendarEvent) => WebCalendarService {
    return function googleLink(event: CalendarEvent): WebCalendarService {
        return {
            label,
            url: googleFn({
                start: event.start,
                end: event.end,
                title: event.title,
                description: descriptionAsHtml(event),
                location: normalizeLocation(event),
                url: event.eventPageUrl,
            }),
            newWindow: true,
            iconBefore: createElement(CalGoogleIcon),
        }
    }
}
